import { SettingsFields } from '@bandido/shared/types';

import { CONFIG } from '@frontend/config';
import { useGetSettingsByAgencyId } from '@frontend/features/agencies/queries';

/**
 * ¿El maestro de lugares está habilitado para la agencia OPERACIONAL
 * (`CONFIG.AGENCY_ID`)? Mismo criterio que el resto de los catálogos de
 * `travel-services`: agencia estática, sin selector en runtime en estas
 * pantallas (documentado en docs/RUTERO.md). El toggle admin en
 * `rutero-view.tsx` sí usa `useParams().id` — es una pantalla de
 * configuración de agencia, no un buscador.
 *
 * Usa el mismo gate general que el backend (`RUTERO_ENABLED`). Places es el
 * único camino de lugares para una agencia con servicios de tierra activos.
 *
 * `undefined` es "no se puede confirmar que esté habilitado" — cubre TANTO
 * "todavía está cargando" COMO "la consulta falló": `useGetSettingsByAgencyId`
 * traga el error en su propio `catch` y devuelve `undefined` en ambos casos,
 * así que este hook no puede distinguirlos sin tocar ese hook compartido (fuera
 * de alcance acá). El llamador decide qué picker mostrar mientras tanto (por
 * defecto, quedarse con el nativo hasta tener una respuesta positiva — nunca
 * asumir habilitado).
 */
export function usePlacesEnabled(): boolean | undefined {
  const { data: settings } = useGetSettingsByAgencyId({
    id: String(CONFIG.AGENCY_ID),
  });
  if (settings === undefined) return undefined;
  return settings[SettingsFields.RUTERO_ENABLED] === 'true';
}
